/* eslint-disable */
import { useState, useEffect, useRef, useMemo } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import JoditEditor from "jodit-react";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  deleteData,
} from "utils/Gateway";

import CommonTabs from "../../CommonTabs/CommonTabs";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { reactSelectStyle } from "Config/Config";
import UploadContentModal from "components/Common/Modal/UploadContentModal";
import LessonSuccessModal from "../Modals/LessonSuccessModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";

const ContentBody = () => {
  const editor = useRef(null);
  const { t } = useTranslation();
  const params = useParams();
  const history = useHistory();
  const token = localStorage.getItem("token");

  const breadcrumbText = [
    { title: t("Course"), link: "/admin/courses" },
    {
      title: t("Lessons"),
      link: `/admin/course/lessons/list/${params.id}`,
    },
    { title: t("Details") },
  ];

  const [chapterList, setchapterList] = useState([]);
  const [memberList, setmemberList] = useState([]);

  const [chapterValue, setchapterValue] = useState(null);
  const [selectedChapterId, setselectedChapterId] = useState(null);
  const [memberValue, setmemberValue] = useState(null);
  const [memberIds, setmemberIds] = useState([]);
  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");
  const [uploadedFiles, setuploadedFiles] = useState([]);
  const [uploadedFileIds, setuploadedFileIds] = useState([]);
  const [videoUrl, setvideoUrl] = useState("");
  const [duration, setduration] = useState("");
  const [passingScore, setpassingScore] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [savedLessonId, setSavedLessonId] = useState(null);

  const [selectedUploadId, setSelectedUploadId] = useState(null);
  const [currentContentIndex, setCurrentContentIndex] = useState(null);
  const [currentContentIdForDelete, setCurrentContentIdForDelete] =
    useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const editorCustomConfig = {
    readonly: false,
    placeholder: "",
    height: 300,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1];
            const newFileName = `image-${timestamp}.${fileExtension}`;
            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;
              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });
                  editorInstance.value = newContent;
                  setdetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "add-new-line",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  const getChapterList = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_COURSE_CHAPTER_LIST_OPTIONS +
        `?token=${token}&courseid=${params.id}`;
      const response = await getData(requestURL);
      if (response.data) {
        setchapterList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAllMemberList = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_COURSE_MEMBER_LIST_OPTIONS +
        `?token=${token}&courseid=${params.id}`;
      const response = await getData(requestURL);
      if (response.status) {
        setmemberList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const chapterSelectionHandler = (val) => {
    setchapterValue(val);
    setselectedChapterId(val ? val.value : null);
  };

  const memberSelectionHandler = (val) => {
    setmemberValue(val);
    setmemberIds(val.map((item) => item.value));
  };

  const deleteContentHandler = async () => {
    if (currentContentIdForDelete && currentContentIndex !== null) {
      try {
        setIsDeleting(true);
        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_CONTENT +
          `/${currentContentIdForDelete}?token=${token}`;
        const response = await deleteData(requestURL);
        setIsDeleting(false);
        if (response.status) {
          const updatedFileids = [...uploadedFileIds];
          const updateFiles = [...uploadedFiles];
          updatedFileids.splice(currentContentIndex, 1);
          updateFiles.splice(currentContentIndex, 1);
          setuploadedFileIds(updatedFileids);
          setuploadedFiles(updateFiles);
          setCurrentContentIndex(null);
          setCurrentContentIdForDelete(null);
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  const getLessonDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_COURSE_LESSON_DETAILS +
        `/${params.lessonid}?token=${token}`;
      const response = await getData(requestURL);
      if (response.status) {
        if (response.data.chapteridvalue) {
          chapterSelectionHandler(response.data.chapteridvalue);
        }
        if (response.data.membervalues) {
          memberSelectionHandler(response.data.membervalues);
        }
        settitle(response.data.title);
        setdetails(response.data.description);
        setuploadedFileIds(response.data?.uploadcontentids);
        setuploadedFiles(response.data?.uploadcontentlist);
        setvideoUrl(response.data.videourl);
        setduration(response.data.duration);
        setpassingScore(response.data.passingscore);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!memberIds || memberIds.length === 0) {
      newErrors.members = t(
        "Please assign at least one member to this lesson."
      );
    }
    if (!title.trim()) {
      newErrors.title = t("A lesson title is required. Please enter one.");
    }
    if (!details || details.trim() === "") {
      newErrors.details = t("Please provide a description for the lesson.");
    }
    if (!uploadedFileIds || uploadedFileIds.length === 0) {
      newErrors.uploadcontent = t(
        "Please attach at least one content file (e.g., PDF, video) to this lesson."
      );
    }
    if (!duration || isNaN(duration) || Number(duration) <= 0) {
      newErrors.duration = t(
        "Please enter a valid duration in minutes (e.g., 60)."
      );
    }
    if (
      !passingScore ||
      isNaN(passingScore) ||
      Number(passingScore) < 0 ||
      Number(passingScore) > 100
    ) {
      newErrors.passingscore = t(
        "Please enter a valid passing score between 0 and 100."
      );
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const saveLessonHandler = async () => {
    if (!validateForm()) {
      setErrorMessage(
        t("Please correct the errors highlighted above before saving.")
      );
      window.scrollTo(0, 0);
      return;
    }
    setErrorMessage(""); // Clear error message if validation passes
    try {
      setIsSaving(true);
      let lessonData = {
        course: params.id,
        chapterid: selectedChapterId,
        title,
        description: details,
        passingscore: passingScore,
        videourl: videoUrl,
        duration,
        members: memberIds,
        uploads: uploadedFileIds,
      };

      let requestURL = url.API_BASE_URL;
      let response = {};

      if (params.lessonid) {
        requestURL +=
          url.API_UPDATE_COURSE_LESSON + `/${params.lessonid}?token=${token}`;
        response = await putData(requestURL, lessonData);
      } else {
        requestURL += url.API_ADD_NEW_COURSE_LESSON + `?token=${token}`;
        response = await postData(requestURL, lessonData);
      }

      setIsSaving(false);
      if (response.status) {
        setSavedLessonId(response.data._id);
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("saveLesson")
        );
        bootstrapModal.show();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const afterSaveLessonModalClose = (saveType = "list") => {
    if (saveType === "list") {
      history.push(`/admin/course/lessons/list/${params.id}`);
    } else if (saveType === "add") {
      history.push(`/admin/course/lessons/content/${params.id}`);
    } else {
      const lessonId = params.lessonid || savedLessonId;
      history.push(`/admin/course/lessons/content/${params.id}/${lessonId}`);
    }
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  useEffect(() => {
    if (params.lessonid) {
      getLessonDetails();
    }
  }, [params.lessonid]);

  useEffect(() => {
    if (params.id) {
      getChapterList();
      getAllMemberList();
    }
  }, [params.id]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.members ? "#dc3545" : "#ced4da",
      "&:hover": { borderColor: errors.members ? "#dc3545" : "#ced4da" },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({ ...base, fontSize: "0.875rem" }),
    singleValue: (base) => ({ ...base, fontSize: "0.875rem" }),
  };

  return (
    <div id="content_wrapper">
      <section className="course-details-wrapper bg-white pb-5">
        {params.lessonid && <CommonTabs activeTab="content" />}
        <div className="container-fluid px-lg-5 pt-4">
          <BreadCrumb
            breadCrumbText={breadcrumbText}
            bottom={true}
            displayName={title}
          />
          <div className="p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="chapter"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Chapter")}
                </label>
                <Select
                  id="chapter"
                  placeholder={t("Select a chapter for this lesson")}
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  isClearable
                  options={chapterList}
                  value={chapterValue}
                  onChange={chapterSelectionHandler}
                />
              </div>

              <div className="form-group mb-4">
                <label
                  htmlFor="members"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Select Members")} <span className="text-danger">*</span>
                </label>
                <Select
                  id="members"
                  isMulti
                  styles={customStyles}
                  placeholder={t("Search and select members for this lesson")}
                  options={memberList}
                  value={memberValue}
                  onChange={(val) => {
                    memberSelectionHandler(val);
                    if (errors.members)
                      setErrors((prev) => ({ ...prev, members: "" }));
                  }}
                />
                {errors.members && (
                  <div className="invalid-feedback d-block">
                    {errors.members}
                  </div>
                )}
              </div>

              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="lessonTitle"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Title")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="lessonTitle"
                  placeholder={t("e.g., Understanding React Components")}
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  value={title}
                  onChange={(e) => {
                    settitle(e.target.value);
                    if (errors.title)
                      setErrors((prev) => ({ ...prev, title: "" }));
                  }}
                />
                {errors.title && (
                  <div className="invalid-feedback d-block">{errors.title}</div>
                )}
              </div>

              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="lessonDetails"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Details")} <span className="text-danger">*</span>
                </label>
                <JoditEditor
                  ref={editor}
                  value={details}
                  config={editorConfig}
                  onBlur={(newContent) => {
                    setdetails(newContent);
                    if (errors.details)
                      setErrors((prev) => ({ ...prev, details: "" }));
                  }}
                />
                {errors.details && (
                  <div className="invalid-feedback d-block">
                    {errors.details}
                  </div>
                )}
              </div>

              <div className="form-group mb-3 mb-sm-4">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Attach Content")} <span className="text-danger">*</span>
                </label>
                <div className="table-wrapper">
                  <div className="table-responsive mb-4">
                    <table className="table align-middle fs-sm text-nowrap border-0 mb-0">
                      <thead>
                        <tr>
                          <th className="course-name bg-transparent fs-md fw-semibold border-0">
                            Rank
                          </th>
                          <th className="assignments bg-transparent fs-md fw-semibold border-0">
                            Title
                          </th>
                          <th className="duration-min bg-transparent fs-md fw-semibold border-0">
                            File
                          </th>
                          <th
                            className="questions bg-transparent fs-md fw-semibold border-0"
                            style={{ width: "40%" }}
                          >
                            Description
                          </th>
                          <th className="action bg-transparent fs-md fw-semibold border-0">
                            Action
                          </th>
                        </tr>
                      </thead>
                      {uploadedFiles.length > 0 && (
                        <tbody>
                          {uploadedFiles.map((content, index) => (
                            <tr key={index}>
                              <td className="course-name border-bottom-0">
                                <p>{content.rank}</p>
                              </td>
                              <td className="questions border-bottom-0">
                                <p className="mb-0">{content.title}</p>
                              </td>
                              <td className="assignments border-bottom-0">
                                <p>{content.name}</p>
                              </td>
                              <td className="created border-bottom-0">
                                <p>{content.description}</p>
                              </td>
                              <td className="action border-bottom-0">
                                <div className="d-flex align-items-center gap-2">
                                  <Link
                                    to="#"
                                    className="text-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#upload_content"
                                    onClick={() =>
                                      setSelectedUploadId(content._id)
                                    }
                                  >
                                    <span className="d-block material-symbols-outlined">
                                      edit
                                    </span>
                                  </Link>
                                  <button
                                    className="text-danger border-0 bg-transparent"
                                    data-bs-toggle="modal"
                                    data-bs-target="#deletewarning"
                                    onClick={() => {
                                      setCurrentContentIndex(index);
                                      setCurrentContentIdForDelete(content._id);
                                    }}
                                    disabled={isDeleting}
                                    style={{
                                      cursor: isDeleting
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    {isDeleting &&
                                    currentContentIndex === index ? (
                                      <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    ) : (
                                      <span className="d-block material-symbols-outlined">
                                        delete
                                      </span>
                                    )}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                  <div className="add_another">
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#upload_content"
                      onClick={() => {
                        if (errors.uploadcontent)
                          setErrors((prev) => ({ ...prev, uploadcontent: "" }));
                      }}
                    >
                      {t("Add Content")}
                    </button>
                  </div>
                </div>
                {errors.uploadcontent && (
                  <div className="invalid-feedback d-block">
                    {errors.uploadcontent}
                  </div>
                )}
              </div>

              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="duration"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Duration (in minutes)")}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  min="1"
                  placeholder={t("e.g., 60")}
                  id="duration"
                  className={`form-control fs-sm shadow-none ${
                    errors.duration ? "is-invalid" : "border border-gray-300"
                  }`}
                  value={duration}
                  onChange={(e) => {
                    setduration(e.target.value);
                    if (errors.duration)
                      setErrors((prev) => ({ ...prev, duration: "" }));
                  }}
                />
                {errors.duration && (
                  <div className="invalid-feedback d-block">
                    {errors.duration}
                  </div>
                )}
              </div>

              <div className="form-group mb-3 mb-sm-4">
                <label
                  htmlFor="passingScore"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Passing Score (%)")}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  id="passingScore"
                  min="0"
                  max="100"
                  placeholder={t("e.g., 75")}
                  className={`form-control fs-sm shadow-none ${
                    errors.passingscore
                      ? "is-invalid"
                      : "border border-gray-300"
                  }`}
                  value={passingScore}
                  onChange={(e) => {
                    setpassingScore(e.target.value);
                    if (errors.passingscore)
                      setErrors((prev) => ({ ...prev, passingscore: "" }));
                  }}
                />
                {errors.passingscore && (
                  <div className="invalid-feedback d-block">
                    {errors.passingscore}
                  </div>
                )}
              </div>

              {errorMessage && (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              )}

              <div className="action d-flex flex-wrap gap-3 align-items-center justify-content-between mt-5">
                <Link
                  to={`/admin/course/lessons/list/${params.id}`}
                  className="btn btn-outline-primary"
                >
                  {t("Cancel")}
                </Link>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={saveLessonHandler}
                  disabled={isSaving}
                  style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                >
                  {t("Save Now")}
                  {isSaving && (
                    <div
                      className="mx-2 spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <UploadContentModal
        selectedUploadId={selectedUploadId}
        setSelectedUploadId={setSelectedUploadId}
        uploadedFiles={uploadedFiles}
        setuploadedFiles={setuploadedFiles}
        uploadedFileIds={uploadedFileIds}
        setuploadedFileIds={setuploadedFileIds}
        setShowAlert={setShowAlert}
        setMessageType={setMessageType}
        setAlertMessage={setAlertMessage}
      />

      <LessonSuccessModal afterSaveModalClose={afterSaveLessonModalClose} />

      <DeleteWarningModal
        onCancelDelete={() => {
          setCurrentContentIndex(null);
          setCurrentContentIdForDelete(null);
        }}
        onDelete={deleteContentHandler}
        moduleName={t("content")}
      />

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default ContentBody;
